import * as React from 'react';
import * as TabsPrimitive from '@radix-ui/react-tabs';
import { cn } from '@/lib/utils';

/**
 * Sober DS (v2) — Tabs. Radix wrappers matching the .tabs / .tabs__tab spec:
 * muted track with inset shadow, active trigger lifts onto bg-sober-surface
 * with shadow-so-card. No colored borders; emphasis via tint + shadow only.
 */
export const Tabs = TabsPrimitive.Root;

export const TabsList = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.List>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.List>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.List
    ref={ref}
    className={cn(
      'inline-flex h-10 items-center gap-1 rounded-so-md bg-sober-muted p-1 shadow-inner',
      className
    )}
    {...props}
  />
));
TabsList.displayName = 'TabsList';

export const TabsTrigger = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Trigger
    ref={ref}
    className={cn(
      'inline-flex items-center justify-center rounded-so-sm px-3.5 py-1.5 text-so-14 font-medium text-sober-secondary transition-colors hover:text-sober-text data-[state=active]:bg-sober-surface data-[state=active]:text-sober-text data-[state=active]:font-bold data-[state=active]:shadow-so-card focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sober-primary-fg focus-visible:ring-offset-2',
      className
    )}
    {...props}
  />
));
TabsTrigger.displayName = 'TabsTrigger';

export const TabsContent = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Content>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Content
    ref={ref}
    className={cn('mt-3 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sober-primary-fg focus-visible:ring-offset-2', className)}
    {...props}
  />
));
TabsContent.displayName = 'TabsContent';
